module.exports = __webpack_public_path__ + "img/vila-franca-xira.38abe185.jpg";